import clsx from 'clsx'

import Checkmark from './CheckmarkNoFill'

const CheckmarkIcon = ({
  postTestState,
}: {
  postTestState: 'passed' | 'not_passed' | 'not_started'
}) => {
  return (
    <Checkmark
      data-testid={postTestState}
      className={clsx(
        postTestState === 'not_passed' && 'text-warning',
        postTestState === 'not_started' && 'text-icon-disabled',
        postTestState === 'passed' && 'text-success'
      )}
    />
  )
}

export default CheckmarkIcon
